import { styled } from '@mui/styles';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StyledToastContainer = styled(ToastContainer)({
  '& .Toastify__toast-body': {
    fontFamily: 'Raleway',
    fontSize: '16px',
    fontWeight: 500,
    color: '#000',
  },
});

export const PopupNotification = () => {
  return <StyledToastContainer closeOnClick autoClose={2000} position={'top-center'} />;
};

export const toastUnfollow = (name) => {
  toast.warning(`Unfollow ${name} !`);
};

export const toastFollow = (name) => {
  toast.success(`You are following ${name} !`);
};
